import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import CartOutlineIcon from 'mdi-react/CartOutlineIcon'
import { useNavigate } from 'react-router-dom'

import { APP_ROUTES } from '@/util/appRoutes'

import { Translation } from '../i18n/Translation'

export const EmptyCart: FC = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center gap-6 py-12 text-center text-gray-600">
      <CartOutlineIcon size={80} className="text-gray-400" />

      <h2 className="text-2xl font-semibold">
        <Translation id="Your cart is empty" />
      </h2>

      <p className="max-w-md text-lg text-gray-500">
        <Translation id="Looks like you haven’t added any products yet. Start exploring and add items to your cart." />
      </p>

      <Button
        variant="secondary"
        onClick={() => navigate(APP_ROUTES.ecomPolicyList)}
        Icon={<CartOutlineIcon />}
      >
        <Translation id="Shop more" />
      </Button>
    </div>
  )
}
